module.exports = __webpack_public_path__ + "img/payment_icon.3eb51df5.png";